module.exports = __webpack_public_path__ + "static/media/gtx.f31478dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/room/rooms/devices/gtx.png
// module id = 3
// module chunks = 0